import { useMemo } from "react"
import type { Tab } from "~/react/components/email_accounts/types"
import { TAB_ORDER } from "~/react/components/email_accounts/utils"

interface UseTabNavigationReturn {
  goToNextTab: (currentTab: Tab) => Tab
  isStepCompleted: (currentTab: Tab, stepTab: Tab) => boolean
  getStepNumber: (stepTab: Tab) => number
}

/**
 * Hook for managing tab navigation logic in the provisioning flow.
 */
export const useTabNavigation = (): UseTabNavigationReturn => {
  const goToNextTab = useMemo(
    () => (currentTab: Tab): Tab => {
      const idx = TAB_ORDER.indexOf(currentTab)
      const next = TAB_ORDER[Math.min(idx + 1, TAB_ORDER.length - 1)]
      return next !== currentTab ? next : currentTab
    },
    [],
  )

  const isStepCompleted = useMemo(
    () => (currentTab: Tab, stepTab: Tab): boolean => {
      const currentIdx = TAB_ORDER.indexOf(currentTab)
      const stepIdx = TAB_ORDER.indexOf(stepTab)
      return stepIdx < currentIdx
    },
    [],
  )

  const getStepNumber = useMemo(
    () => (stepTab: Tab): number => {
      return TAB_ORDER.indexOf(stepTab) + 1
    },
    [],
  )

  return {
    goToNextTab,
    isStepCompleted,
    getStepNumber,
  }
}

